/**
 * key : 'VUE_APP_COMPANY_ID'
 *  - router
 *    - model [一个页面可能存在多个COMPONENTS] 对应 SpComponent 组件 的 myName 属性 以及对应的 handle;
 */
export default {
  './route-drainage.js': { 'channelCode/:id': () => import('./drainage/channelCodeEdit') },
  './route-index.js': { 'home': () => import('./home/index') },
  './route-setting.js': { 'account': () => import('./setting/account') },
  './route-customerConversion.js': {
    'welcomeLanguage/:id': () => import('./customerConversion/welcomeLanguageEdit')
  }
}
